module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Feel the bile rising from your guilty past")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With your nerves in tatters")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As the cockleshell shatters")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And the hammers batter down your door")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You’d better run …”")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—Roger Waters/Pink Floyd ")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Run Like Hell")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31bce514","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 75
// module chunks = 0